import styled from 'styled-components';

import { COLORS } from '~/src/common/theme';

const ErrorMessage = styled.span`
  display: inline-block;

  font-size: 12px;
  line-height: 16px;
  color: ${COLORS.NEUTRAL_NOTIFICATION};
`;

export default ErrorMessage;
